module.exports = __webpack_public_path__ + "img/08_noff_open_L3.08656ced.svg";